import styled from 'styled-components'

export const MarginalContent = styled.div`
	padding: 0 16px;

	h3 {
		margin: 0;
	}
`
